import { render, staticRenderFns } from "./PaymentOtc.vue?vue&type=template&id=c919dec8&"
import script from "./PaymentOtc.vue?vue&type=script&lang=js&"
export * from "./PaymentOtc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports